export default {
  download: {
    'documentTitle': 'ORS route',
    'download': 'Download',
    'downloadFileName': 'Scarica il nome del file',
    'downloadFormat': 'Scarica il formato',
    'downloadRoute': 'Scarica il percorso',
    'preparingDownload': 'Preparando il download ...',
    'fileReady': 'Il file è pronto',
    'errorPreparingFile': 'Errore nel preparare il file',
    'fileTooBigToBeDownloaded': 'Il file è troppo grande per essere scaricato',
    'standard': 'Standard'
  }
}
